// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2hPiL","paramInput":"JobSimulator_paramInput__ohKkK","input":"JobSimulator_input__11p8b"};